(function () {
    'use strict';
    var $ = window.jQuery;

    function News(options) {
        if (!options) {
            throw new Error('No options passed to News constructor');
        }

        this.options = $.extend({}, News.defaults, options);

        this.tableInit();
    }

    News.prototype.tableInit = function () {
        var $self = this
        var sportCategory = false;

        var table = $('#news-table').DataTable({
            paging: true,
            bFilter: false,
            pageLength: $self.options.limit,
            searching: false,
            info: false,
            lengthChange: true,
            processing: true,
            serverSide: true,
            ordering: true,
            columns:[
                {
                    "sortable": true
                },
                {
                    "sortable": false
                },
                {
                    "sortable": true
                }
            ],
            'ajax': {
                'url': '/wp-json/arkansas/v2/load_datatable_news',
                'dataType': 'json',
                'contentType': 'application/json; charset=utf-8',
                'data': function (d) {
                    d.sportCategory = sportCategory;
                }
            }
        });

        $('#by-sport').on('change', function (event) {
            event.preventDefault();
            sportCategory = $(this).val();
            table.draw();
        });
    };

    window.News = News;
}());